/* eslint-disable */
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment";
import { PageWrapper, TableWrapper } from "../../../../shared/layout";
import { templateStrings } from "../../../../Constant";
import { BarLoader } from "../../../../shared/widgets";
import { setTokenExpired } from "../../../../redux/actions/authActions";
import { setNotificationMessage } from "../../../../redux/actions/notificationAction";

class PreviousSettlementDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
      content: [],
      pageNo: 0,
      rowsPerPage: 10,
      count: 100,
      selected: [],
      vehicleDetails: null,
    };
  }

  componentDidMount() {
    this.setState({
      vehicleDetails: this.props.location.state.vehicleDetails,
    });
  }

  render() {
    const templateString = templateStrings.currentDueVehicleList;
    const header = `${
      (this.state.vehicleDetails
        && this.state.vehicleDetails.paymentDate
        && moment(this.state.vehicleDetails.paymentDate).format("DD MMM YYYY"))
      || "Detail"
    }`;
    const content = (this.state.vehicleDetails && this.state.vehicleDetails.buses) || [];

    const { headerLoader, totalItems } = this.props;
    const { selected, pageNo, rowsPerPage } = this.state;
    return (
      <div>
        <PageWrapper>
          <div className="page-header">
            <div
              className="back-arrow"
              onClick={() => {
                const { history } = this.props;
                history.go(-2);
                // history.replace("/settlement/operator-settlement", this.props.location.state.state);
              }}
              onKeyDown={(event) =>
                {
                  if (event.key === "Enter") {
                    const { history } = this.props;
                    history.go(-2);
                  }
                } 
              }
            >
              <div className="back-action" />
            </div>
            <div className="page-header-title">{header}</div>
          </div>
          <BarLoader scope="header" />
          <TableWrapper
            selected={selected}
            content={!headerLoader && content}
            pageNo={pageNo}
            uniqueKey="_id"
            removePagination
            rowsPerPage={rowsPerPage}
            count={totalItems}
            templateString={templateString}
            selectionAllowed={false}
          />
        </PageWrapper>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  headerLoader: (state && state.loadingBar && state.loadingBar.header),
});

const mapDispatchToProps = (dispatch, state) => ({
  initiateNotification: (value) => {
    dispatch(setNotificationMessage(value));
  },
  setTokenExpired: (value) => {
    dispatch(setTokenExpired(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PreviousSettlementDetail));
